import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '24px',
    '& table:first-child': {
      display: 'block',
      overflowY: 'hidden',
      overflowX: 'auto'
    }
  }
}));
